<template>
  <div id="recuperar-senha">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-login" style="margin-bottom: 40px">
            <div class="loader"></div>
            <div id="form">
              <h2 class="card-title text-center">Recuperar Senha</h2>
              <div class="row">
                <form @submit.prevent="recuperar()">
                  <div class="col-12">
                    <div class="form-group input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="icofont-card"></i>
                        </span>
                      </div>
                      <the-mask
                        v-model="cpf"
                        :mask="['###.###.###-##']"
                        class="cpf form-control"
                        placeholder="CPF"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <vue-recaptcha
                      @verify="onVerify"
                      sitekey="6LcYTQ4pAAAAAPPhg0Hj_82xp9l1mCXiboBchT5o"
                    >
                    </vue-recaptcha>
                  </div>
                  <div class="col-12">
                    <button type="submit" class="btn float-right">
                      <span v-if="!loading"> Recuperar </span>
                      <b-spinner
                        label="Spinning"
                        small
                        variant="white"
                        v-if="loading"
                      ></b-spinner>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="offset-md-4 col-md-4 col-12">
          <div class="d-flex align-items-center justify-content-center">
            <router-link to="/login">
              <button class="btn">
                <i class="icofont-arrow-left"></i> Voltar
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import { TheMask } from 'vue-the-mask'

export default {
  components: {
    TheMask,
    'vue-recaptcha': VueRecaptcha,
  },
  data() {
    return {
      cpf: '',
      loading: false,
      size: '40px',
      color: '#0D98BB',
      robot: false,
    }
  },
  methods: {
    onVerify: function (response) {
      if (response) this.robot = true
    },

    recuperar() {
      if (this.robot) {
        if (this.cpf == '') {
          this.$toast.error('Informe um CPF válido.', 'Erro:', {
            position: 'topRight',
          })
          return
        }

        let user = {
          cpf: this.cpf,
        }

        this.loading = true
        this.$apiPublic
          .post('/recuperar-senha', user)
          .then((response) => {
            if (response.data.error == true) {
              this.$toast.error(response.data.message, 'Error:', {
                position: 'topRight',
              })
            } else {
              this.$toast.success(response.data.message, 'Sucesso:', {
                position: 'topRight',
              })
            }
            this.loading = false
          })
          .catch((error) => {
            console.log(error)
            this.loading = false
            switch (error.response.status) {
              case 500:
                this.$toast.error(
                  'Erro ao recuperar senha! Por favor, entre em contato com o suporte.',
                  'Erro:',
                  {
                    position: 'topRight',
                  }
                )
                break
              default:
                break
            }
          })
          .finally(() => {
            this.loading = true
          })
      } else {
        this.loading = false
        this.$toast.error('Verificação inválida!', 'Erro:', {
          position: 'topRight',
        })
      }
    },
  },
}
</script>

<style>
#recuperar-senha {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.response-text {
  padding: 14px;
  background: #f2f2f2;
  margin: 40px auto;
}

.response-text h2 {
  margin-bottom: 0px;
  text-align: center;
}
</style>
